'use client';

import { ReactNode, useEffect } from 'react';

import { useMobile } from '@shared/hooks';

import { ProfileContactInfoDesktopLayout } from './ProfileContactInfoDesktopLayout';
import { ProfileContactInfoMobileLayout } from './ProfileContactInfoMobileLayout';

export const ProfileContactInfoLayout = ({ children }: { children: ReactNode }) => {
  const isMobile = useMobile();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className='w-full flex flex-col'>
      {isMobile ? (
        <ProfileContactInfoMobileLayout>{children}</ProfileContactInfoMobileLayout>
      ) : (
        <ProfileContactInfoDesktopLayout>{children}</ProfileContactInfoDesktopLayout>
      )}
    </div>
  );
};
